import { render, staticRenderFns } from "./CompetitionAndMarketPanel.vue?vue&type=template&id=301c7ba6&scoped=true&"
import script from "./CompetitionAndMarketPanel.vue?vue&type=script&lang=ts&"
export * from "./CompetitionAndMarketPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301c7ba6",
  null
  
)

export default component.exports